<template>
  <v-list id="list" style="background: #000;" two-line class="mt-6">
    <template v-for="item in items">
      <router-link
        id="world_route_btn"
        :key="item.name"
        :to="`/account/${userName}/${item.name}`"
      >
        <v-list-item :key="item.title">
          <v-list-item-action>
            <v-icon size="27.11" :style="item.color">
              {{
              item.icon
              }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle class="white--text" v-if="item.subtitle">
              {{
              item.subtitle
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </router-link>
    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    items: null,
    subHeader: String,
    userName: String
  },
  data() {
    return {};
  }
};
</script>

<style>
 .v-sheet {
  border-radius: 0 !important;
}
.v-card {
  box-shadow: none !important;
}
</style>